module.exports = __webpack_public_path__ + "img/img_4.195cd6e5.png";